function e(e){return"ethereum"===e.type}export{e as isBaseConnectedEthereumWallet};
